export const enum TagKey {
  AdminSchoolLinks = 'adminSchoolLinks',
  SchoolLinks = 'schoolLinks',
  UserSettings = 'userSettings',
}
